declare let bauminatorTrans :any;
declare let translations :any;


export const translate = (key: string) => {
    if (bauminatorTrans['bauminator_'+key]){
        return bauminatorTrans['bauminator_'+key];
    } 
    else if(translations && translations[key]){
        return translations[key];
    }
    else {
        return key;
    }
}